// extracted by mini-css-extract-plugin
export default {"text":"ReadMore_text__0aFzl","readOrHide":"ReadMore_readOrHide__djV0y"};